export default __webpack_public_path__ + "d231cdc9513899d3cb86247cd14dda0e.svg";